import { LoadingBar } from 'view-design'
import router from './router'
import store from './store'
import createRoutes from '@/utils/createRoutes'
import { getDocumentTitle, resetTokenAndClearUser } from './utils'
import request from '@/utils/request'

// 是否有菜单数据
let hasMenus = false
router.beforeEach(async (to, from, next) => {
    document.title = getDocumentTitle(to.meta.title)
    LoadingBar.start()
    if (localStorage.getItem('token') && localStorage.getItem('userId') && localStorage.getItem('workshop')) {
        if (to.path === '/login') {
            next({ path: '/' })
        } else if (hasMenus) {
            next()
        } else {
            try {
                // 这里可以用 await 配合请求后台数据来生成路由
                const data = await request.get('/api/Menu/GetHomeMenu', {
                    params: {
                        userId: parseInt(localStorage.getItem("userId"))
                    }
                })
				var menuData = data.data
				menuData.unshift({
					value:0,
					name:"home",
					title:"主页",
					expand:true,
					Checked:false,
					size:0,
					url:"home",
					menuIcon:"home.png",
					text:"主页"
				})
                store.commit('setMenus', menuData)
                const routes = createRoutes(menuData)
                // 动态添加路由
                router.addRoutes(routes)
                hasMenus = true
                next({ path: to.path || '/' })
            } catch (error) {
                resetTokenAndClearUser()
                next(`/login?redirect=${to.path}`)
            }
        }
    } else {
        hasMenus = false
        if (to.path === '/login') {
            next()
        } else if (to.path === '/productintroduction') {
            next()
        } else if(to.path === '/documentshare'){
			next()
		}else if(to.path === '/supplierreconciliationlistshare'){
			next()
		}else if(to.path === '/customerreconciliationlistshare'){
			next()
		}else {
            next(`/productintroduction?redirect=${to.path}`)
        }
    }
})

router.afterEach(() => {
    LoadingBar.finish()
})
